export default __webpack_public_path__ + "static/media/ayudaBAcudirJDE.6d37e960.png";